import Vue from 'vue'
import './plugins/axios'
import App from './views/App.vue'
import router from './router'
import '@/assets/css/style.css'
import Localization from './localization'
import application from './controllers/ApplicationController'
import api from './lib/ServerApi'
import SortedTablePlugin from "vue-sorted-table";
import VueGtag from 'vue-gtag';

Vue.use(SortedTablePlugin);
Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {
    id: 'G-5LVCKFSHBC',     // ← your Measurement ID (must match customToolbar.js)
    params: {
      send_page_view: false  // we fire manual page_views so disable auto
    }
  }
}, router)

// ---- Helper: apply GA identity & user properties once user is known ----
function applyGaIdentity(user) {
  if (!user || Object.keys(user).length === 0) return;

  // ✅ Persist all identity fields to localStorage so:
  //    1. customToolbar.js (PDF viewer tab) can read them for page_view events
  //    2. Both Vue components can read them for file_download events
  try {
    // tci_user_id stores the username — used as user_name in all GA events
    if (user.username)   localStorage.setItem('tci_user_id',     String(user.username));
    if (user.userType)   localStorage.setItem('tci_user_type',   String(user.userType));
    if (user.brand)      localStorage.setItem('tci_brand',       String(user.brand));
    if (user.dealerCode) localStorage.setItem('tci_dealer_code', String(user.dealerCode));
    if (user.language)   localStorage.setItem('tci_language',    String(user.language));
  } catch (e) {
    console.warn('[GA] Unable to persist identity for viewer:', e);
  }

  // 1) Attach user_id to GA4 config for this property
  if (window.gtag) {
    window.gtag('config', 'G-5LVCKFSHBC', {   // ← same Measurement ID as above
      user_id:        user.username || undefined,
      send_page_view: false
    });
  }

  // 2) Set GA4 user_properties (shown in GA4 user explorer & audiences)
  if (window.gtag) {
    window.gtag('set', 'user_properties', {
      user_name:   user.username   || undefined,
      user_type:   user.userType   || undefined,
      brand:       user.brand      || undefined,
      dealer_code: user.dealerCode || undefined,
      language:    user.language   || undefined
    });
  }

  // 3) Fire an immediate page_view for the current route now that identity is set
  if (window.gtag && router && router.currentRoute) {
    window.gtag('event', 'page_view', {
      page_path:     router.currentRoute.fullPath,
      page_title:    (router.currentRoute.meta && router.currentRoute.meta.title) ||
                     router.currentRoute.name ||
                     document.title,
      page_location: window.location.origin + router.currentRoute.fullPath,

      // ✅ User & dealer directly on the event for reliable GA4 reporting
      user_name:   user.username   || undefined,
      dealer_code: user.dealerCode || undefined,
      brand:       user.brand      || undefined,
      user_type:   user.userType   || undefined
    });
  }
}

window.code = new Vue({
	router,
	created: function(){
		this.init();
	},
	data: function(){
		return {
			Localization: null,
			application: null,
			reports: null,
			busy: null,
			networkError: null
		}
	},
	methods: {
		init: function(){
			this.Localization = Localization;
			Vue.prototype.$Localization = this.Localization;

			Vue.filter('datetime', function(value) { return Localization.datetime(value)});
			Vue.filter('date', function(value) { return Localization.date(value)});
			Vue.filter('str', function(value) { return Localization.str(value)});

			this.application = application;
			Vue.prototype.$application = this.application;

			this.api = api
			Vue.prototype.$api = this.api;

			// wait unit all references are initialized
			application.init();
			application.initPromise.then(() => {
				const user = application.getUser && application.getUser();
			// (Optional) keep your localization behavior
				const lang = localStorage.getItem('language') || (user && user.language);
				if (lang) Localization.setLanguage(lang);

				// ✅ Now safe to apply identity & user properties
				applyGaIdentity(user);
			});
		}
	},
	render: function (h) { return h(App) }
}).$mount('#app');
